/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_Faq_Q1Inputs */

const en_guide_json_vs_yaml_xml_faq_q1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is YAML a superset of JSON?`)
};

const ko_guide_json_vs_yaml_xml_faq_q1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML은 JSON의 상위 집합인가요?`)
};

const ja_guide_json_vs_yaml_xml_faq_q1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAMLはJSONのスーパーセットですか？`)
};

/**
* | output |
* | --- |
* | "Is YAML a superset of JSON?" |
*
* @param {Guide_Json_Vs_Yaml_Xml_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_faq_q1 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_faq_q1(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_faq_q1(inputs)
	return ja_guide_json_vs_yaml_xml_faq_q1(inputs)
});